// extracted by mini-css-extract-plugin
module.exports = {"light":"TaskInput_light__2tAU_","dark":"TaskInput_dark__1x8nB"};